module.exports = __webpack_public_path__ + "static/media/Crater_Lake.f1270aac.jpg";